import axios from "axios"

export default {
  /**
   *
   * @param commit
   * @param params
   * @returns {Promise<unknown>}
   */
  addNewPartner({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers/${params.id}/register`, params.body).then(res => {
        resolve(res.data);
      }, error => {
        reject(error.response.data.errorMessage)
      })
    })
  },
  /**
   *
   * @param commit
   * @param params
   * @returns {Promise<unknown>}
   */
  loadDealerName({commit}, uuid) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/dealers/${uuid}/get-dealer-name`).then(res => {
        resolve(res.data);
      }, error => {
        reject(error)
      })
    })
  },
  /**
   *
   * @param commit
   * @param params
   * @returns {Promise<unknown>}
   */
  loadPartner({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/dealers/${params.uuid}/get-parent-dealer`).then(res => {
        resolve(res.data);
        commit('updatePartner', res.data);
      }, error => {
        reject(error)
      })
    })
  },
  /**
   *
   * @param commit
   * @returns {Promise<unknown>}
   */
  loadPartnerActivity({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/dealers/activities`).then(res => {
        resolve(res.data);
        commit('updatePartnerActivity', res.data);
      }, error => {
        reject(error)
      })
    })
  }
}
